export default __webpack_public_path__ + "static/581264730712b0efd6ee076310ac6b5b.png";